import { createStore } from 'vuex'
import createPersistedstate from 'vuex-persistedstate'

import user from './modules/user'
import cart from './modules/cart'
import category from './modules/category'
import video from './modules/video'

// 创建vuex仓库并导出
export default createStore({
  modules: {
    user,
    cart,
    category,
    video
  },
  plugins: [
    createPersistedstate({
      key: 'shweb',
      paths: ['user', 'cart']
    })
  ]
})